// @ts-nocheck
import { fmtDuration } from '../shared/voteRoomFormat';
import { getShareholderVoteStatus } from '../shared/voteRoomVoteStatus';
import { VoteRoomSlideOver } from './VoteRoomSlideOver';
import { VoteRoomShareholderSummary } from './VoteRoomShareholderSummary';

/** Slide-over showing per-document read times for a single shareholder, plus the summary card. */
export const ViewActivitySlideOver = ({ shareholder, shareholders, eligibleShares, voteRoomClosed, onClose }) => {
  const active = shareholder ? shareholders.find((s) => s.id === shareholder.id) || shareholder : null;
  const disc = active?.docViews?.find((v) => v.doc === 'disclosure');
  const cons = active?.docViews?.find((v) => v.doc === 'consent');
  const total = (disc?.totalSeconds || 0) + (cons?.totalSeconds || 0);
  const statusVariant = active ? getShareholderVoteStatus(active, { voteRoomClosed }) : null;

  return (
    <VoteRoomSlideOver
      open={shareholder != null}
      onClose={onClose}
      title="View Activity"
      titleId="vote-room-activity-slide-title"
      subtitle={active?.name}
      statusVariant={statusVariant}
    >
      {active ? (
        <div className="space-y-5">
          <VoteRoomShareholderSummary
            shareholder={active}
            eligibleShares={eligibleShares}
            voteRoomClosed={voteRoomClosed}
          />
          <div>
            <h4 className="mb-2 text-xs font-semibold uppercase tracking-wider text-gray-500">Document Activity</h4>
            <div className="divide-y divide-gray-100 overflow-hidden rounded-lg border border-gray-100 bg-gray-50/50">
              <div className="flex items-center justify-between px-4 py-3 text-xs">
                <span className="text-gray-600">Disclosure</span>
                <span className="font-medium text-gray-900 tabular-nums">
                  {disc ? fmtDuration(disc.totalSeconds) : '—'}
                </span>
              </div>
              <div className="flex items-center justify-between px-4 py-3 text-xs">
                <span className="text-gray-600">Consent</span>
                <span className="font-medium text-gray-900 tabular-nums">
                  {cons ? fmtDuration(cons.totalSeconds) : '—'}
                </span>
              </div>
              <div className="flex items-center justify-between px-4 py-3 text-xs">
                <span className="font-semibold text-gray-700">Total</span>
                <span className="font-semibold text-gray-900 tabular-nums">{total > 0 ? fmtDuration(total) : '—'}</span>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </VoteRoomSlideOver>
  );
};
